/**
 * Haptic Feedback Utility for iOS/Android Native Apps
 * 
 * Provides haptic feedback on key user actions for a polished native feel.
 * Only triggers on native platforms (iOS/Android), no-op on web.
 */

import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

// Check if we're on a native platform
const isNative = Capacitor.isNativePlatform();

/**
 * Light impact - for toggle switches, minor selections
 */
export const hapticLight = async () => {
  if (!isNative) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch (e) {
  }
};

/**
 * Medium impact - for button taps, confirmations
 */
export const hapticMedium = async () => {
  if (!isNative) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Medium });
  } catch (e) {
  }
};

/**
 * Heavy impact - for important actions, deletions
 */
export const hapticHeavy = async () => {
  if (!isNative) return;
  try {
    await Haptics.impact({ style: ImpactStyle.Heavy });
  } catch (e) {
  }
};

/**
 * Success notification - for successful form submissions, bookings confirmed
 */
export const hapticSuccess = async () => {
  if (!isNative) return;
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch (e) {
  }
};

/**
 * Warning notification - for warnings, validation errors
 */
export const hapticWarning = async () => {
  if (!isNative) return;
  try {
    await Haptics.notification({ type: NotificationType.Warning });
  } catch (e) {
  }
};

/**
 * Error notification - for errors, failed actions
 */
export const hapticError = async () => {
  if (!isNative) return;
  try {
    await Haptics.notification({ type: NotificationType.Error });
  } catch (e) {
  }
};

/**
 * Selection changed - for picker selections, segment changes
 */
export const hapticSelection = async () => {
  if (!isNative) return;
  try {
    await Haptics.selectionChanged();
  } catch (e) {
  }
};

// Default export for convenience
export default {
  light: hapticLight,
  medium: hapticMedium,
  heavy: hapticHeavy,
  success: hapticSuccess,
  warning: hapticWarning,
  error: hapticError,
  selection: hapticSelection,
};
